import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { SimProvider } from '../types';

interface SimInventoryHeaderProps {
  provider: SimProvider;
  onProviderChange: (provider: SimProvider) => void;
  onRefresh: () => void;
  isRefreshing: boolean;
}

const PROVIDER_SUBTITLES: Record<SimProvider, string> = {
  jasper: 'Jasper (Bell) IoT SIM Management',
  telnyx: 'Telnyx IoT SIM Management',
};

export function SimInventoryHeader({
  provider,
  onProviderChange,
  onRefresh,
  isRefreshing,
}: SimInventoryHeaderProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <h1 className="page-title">
        SIM Card Inventory <small>{PROVIDER_SUBTITLES[provider]}</small>
      </h1>

      <div className="flex items-center gap-2">
        <div
          className="flex items-center gap-1 rounded-md border p-0.5"
          aria-label="SIM provider"
        >
          <Button
            variant={provider === 'jasper' ? 'secondary' : 'ghost'}
            size="sm"
            className="h-8"
            onClick={() => onProviderChange('jasper')}
            aria-pressed={provider === 'jasper'}
          >
            Jasper (Bell)
          </Button>
          <Button
            variant={provider === 'telnyx' ? 'secondary' : 'ghost'}
            size="sm"
            className="h-8"
            onClick={() => onProviderChange('telnyx')}
            aria-pressed={provider === 'telnyx'}
          >
            Telnyx
          </Button>
        </div>

        <Button
          variant="outline"
          onClick={onRefresh}
          disabled={isRefreshing}
          title={`Refresh ${provider === 'telnyx' ? 'Telnyx' : 'Jasper'} SIM inventory`}
          aria-label={`Refresh ${provider === 'telnyx' ? 'Telnyx' : 'Jasper'} SIM inventory`}
        >
          <RefreshCw className={`mr-2 h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
          Refresh Inventory
        </Button>
      </div>
    </div>
  );
}
